import { MantineColor } from "@mantine/core";

export const MANTINE_COLORS: MantineColor[] = [
    'green',
    'dark',
    'gray',
    'red',
    'pink',
    'grape',
    'violet',
    'indigo',
    'blue',
    'cyan',
    'teal',
    'lime',
    'dark.6',
    'gray.6',
    'red.6',
    'pink.6',
    'grape.6',
    'violet.6',
    'indigo.6',
    'blue.6',
    'cyan.6',
    'teal.6',
    'green.6',
    'lime.6',
];

type ValueOf<T> = T[keyof T];

export function makeColorMap<E extends Record<string, string>>(
    e: E,
    palette?: Record<string, MantineColor>,
): Record<ValueOf<E>, MantineColor> {
    const values = (Object.values(e) as ValueOf<E>[]).sort();
    return values.reduce((acc, val, i) => {
        acc[val] = palette?.[val as string] ?? MANTINE_COLORS[i % MANTINE_COLORS.length];
        return acc;
    }, {} as Record<ValueOf<E>, MantineColor>);
}